<ng-container *ngIf="blocks[0]">
  <app-data-group *ngIf="blocks[0].contentJSON.cols[0].col[0].paramJSON"
    [widgetId]="blocks[0].contentJSON.cols[0].col[0].paramJSON.widgetId"
    [src]="blocks[0].contentJSON.cols[0].col[0].paramJSON.dataGroup"
    [dataGroup]="blocks[0].contentJSON.cols[0].col[0].paramJSON.dataGroupJSON"
    [params]="blocks[0].contentJSON.cols[0].col[0].paramJSON.params">
  </app-data-group>
</ng-container>

